import * as React from "react";
import { useState, useEffect } from "react";
import { Col, Row, Button, Container, Accordion, Image, Table, Tabs, Tab, Navbar, Nav } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import "../index.css";
import { ViewAndDownload } from "../Modules/Helper";
import { Helmet } from "react-helmet";
import Footer from "../Modules/Footer";
import NavigationBar from "../Modules/NavigationBar";
import settingsvg from "../faq/app-setting.svg"
import soundsettingsvg from "../faq/app-soundsetting.svg"

export default function FAQ_EN() {
	const [tabKey, setTabKey] = useState<string | undefined>(undefined);
	const [accordionKey, setAccordionKey] = useState<string | undefined>(undefined);


	function scrollToSVGandHighlight(id: string) {
		var e = document.getElementById(id);

		highlightSVG(id);
		if (!checkVisible(e))
			e?.scrollIntoView({
				block: "center",
				behavior: "smooth",
			});
	}
	function highlightSVG(id: string) {
		var e = document.getElementById(id);

		e?.setAttribute("style", "transform:scale(3);filter: invert(53%) sepia(61%) saturate(2332%) hue-rotate(339deg) brightness(99%) contrast(103%) ;");

		setTimeout(() => {
			e?.setAttribute("style", "transform:scale(1.5); ");
		}, 2000);
	}

	function scrollToIDandHighlight(id: string) {
		var e = document.getElementById(id);

		highlightID(id);
		if (!checkVisible(e))
			e?.scrollIntoView({
				block: "center",
				behavior: "smooth",
			});
	}
	function highlightID(id: string) {
		var e = document.getElementById(id);
		e?.setAttribute("style", "color:#ff6d2d; ");

		setTimeout(() => {
			e?.setAttribute("style", "color:black; ");
		}, 2000);
	}

	function scrollToIDwithOffset(id: string) {
		var e = document.getElementById(id);
		var headerOffset = 100;
		var elementPosition = e?.getBoundingClientRect().top ?? 0;
		var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

		if (!checkVisible(e))
			window.scrollTo({
				top: offsetPosition,
				behavior: "smooth",
			});
	}

	function checkVisible(elm: any) {
		var rect = elm.getBoundingClientRect();
		var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
		return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
	}

	function handleTabChange(event: any) {
		setTabKey(event);
		if (event === "app") {
			highlightSVG("geluidsinstellingen-a");
			highlightID("row-geluidsinstellingen-a");
		}
		if (event === "app2") {
			highlightSVG("instellingen-a");
			highlightID("row-instellingen-a");
		}
	}

	function handleAccordionChange(event: any) {
		setAccordionKey(event);
	}
	return (
		<>
			<Helmet>
				<title>{"EarsOnly | FAQ - EN"}</title>
			</Helmet>
			<NavigationBar />
			<Container className="container-padding">
				<h1>Support</h1>

				<Tab.Container
					onSelect={(key) => handleTabChange(key)}
					defaultActiveKey=""
					activeKey={tabKey}
				>
					<Row className="faq-menu">
						<Col lg={3}>
							<Nav
								activeKey={tabKey}
								variant="pills"
								className="flex-column faq-menu-list"
							>
								<Nav.Item>
									<Nav.Link
										onClick={() => scrollToIDwithOffset("connect-bluetooth")}
										eventKey="connect-bluetooth"
									>
										Pairing
									</Nav.Link>
								</Nav.Item>
								<Nav.Item>
									<Nav.Link
										onClick={() => scrollToIDwithOffset("checking-battery")}
										eventKey="checking-battery"
									>
										Battery
									</Nav.Link>
								</Nav.Item>
								<Nav.Item>
									<Nav.Link
										onClick={() => scrollToIDwithOffset("cleaning-eop")}
										eventKey="cleaning-eop"
									>
										Cleaning & Maintenance
									</Nav.Link>
								</Nav.Item>

								<Nav.Item onClick={() => scrollToIDwithOffset("app")}>
									<Nav.Link eventKey="app">MyEarsOnly app</Nav.Link>
								</Nav.Item>
								<Nav.Item className="faq-spacer">
									<Nav.Link
										onClick={() => scrollToIDwithOffset("app2")}
										eventKey="app2"
									>
										Settings
									</Nav.Link>
								</Nav.Item>
								<Nav.Item className="faq-spacer">
									<Nav.Link
										onClick={() => scrollToIDwithOffset("troubleshooting")}
										eventKey="troubleshooting"
									>
										Troubleshooting
									</Nav.Link>
								</Nav.Item>
								<Nav.Item>
									<Nav.Link
										onClick={() => scrollToIDwithOffset("downloads")}
										eventKey="downloads"
									>
										Downloads{" "}
									</Nav.Link>
								</Nav.Item>
							</Nav>
						</Col>
						<Col lg={9}>
							<Tab.Content>
								<Tab.Pane eventKey={""}>
									<h2
										id="connect-bluetooth"
										className="faq-menu-header"
									>
										Support EarsOnly Protect
									</h2>
									Welcome to the support page of the EarsOnly Protect.
									<br />
									Here you can find information about the EarsOnly Protect and troubleshooting steps. <br />
									If you've still got an issue, please reach out via the contact form
								</Tab.Pane>

								<Tab.Pane eventKey="connect-bluetooth">
									<h2
										id="connect-bluetooth"
										className="faq-menu-header"
									>
										How do I pair my EarsOnly Protect to a device?
									</h2>
									<Row>
										<Col>
											<ol>
												<>
													Download the MyEarsOnly app by scanning the QR-code to the right or from the {" "}
													<a
														className="faq-link"
														target="_blank"
														href="https://app.earsonly.nl/download"
														rel="noreferrer"
													>
														Google Play Store or Apple App Store.
													</a>{" "}
													Follow the instructions in the app, or manually pair EarsOnly Protect with a device as explained below:
												</>
												<li>Ensure that the Charging Case is charged to at least 25%.</li>
												<small>
													<b>Tip: </b> go to{" "}
													<a
														className="faq-link"
														href="#checking-battery"
														onClick={() => handleTabChange("checking-battery")}
													>
														"Charging and checking battery status"
													</a>{" "}
													for guidance on checking the battery levels.{" "}
												</small>
												<li>Make sure the Earbuds are properly placed in the Charging Case.</li>
												<li>Press and hold the button on the Charging Case for 3 seconds. Wait until all three lights blink; this may take up to 10 seconds.</li>
												<li>
													Open the Bluetooth® menu on your device and select “Connect new device” (this may vary by device, refer to the respective manual).
												</li>
												<li>When all three lights on the Charging Case blink, “EarsOnly Protect” will appear in the list.</li>
												<li>Select “EarsOnly Protect” from the list to connect.</li>
											</ol>
										</Col>
										<Col lg={4}>
											<Row>
												<Col
													xs={5}
													lg={10}
												>
													<Image
														fluid
														src="images/faq/scan_QRcode.svg"
													/>
												</Col>
												<Col
													xs={5}
													lg={10}
												>
													<Image
														fluid
														src="images/faq/pairing.svg"
													/>
												</Col>
											</Row>
										</Col>
									</Row>
								</Tab.Pane>

								<Tab.Pane eventKey="checking-battery">
									<h2
										id="checking-battery"
										className="faq-menu-header"
									>
										How do I check the battery levels and charge the batteries?
									</h2>
									<Row>
										<Col>
											<ol>
												<Row>
													<Col className="faq-battery-text">
														<br />
														<li>Open the lid of the Charging Case.</li>
														<li>Check the battery status of the Charging Case, indicated by the middle LED (Figure 1).</li>
														<li>
															When the battery is low, connect the Charging Case using the provided USB-C cable and a USB charger port or place the case on a Qi compatible wireless charge pad.
														</li>
													</Col>
													<Col
														lg={4}
														className="faq-battery-image"
													>
														<Image
															src="images/faq/case_battery_light.svg"
															fluid
														/>
														<Col className="faq-battery-image-title">
															<small>Figure 1</small>
														</Col>
													</Col>
												</Row>
												<Row>
													<Col className="faq-battery-text">
														<li>
															Place the earbud (left or right) on the corresponding charging contacts (Figure 2).  <br />
															<small>
																<b> Warning:</b> Ensure that the charging contacts of both the Earbuds and the Charging Case are free from dirt. (see:{" "}
																<a
																	className="faq-link"
																	href="#cleaning-eop"
																	onClick={() => handleTabChange("cleaning-eop")}
																>
																	{" "}
																	"Cleaning & Maintenance"
																</a>
																). If there is poor or no contact, the Earbuds will not start charging.
															</small>
														</li>
														<li>
															When the Earbud is placed in the Charging Case, the corresponding left or right light will briefly illuminate to indicate a good connection (Figure 2).
														</li>
														<li>Repeat for the other Earbud.</li>
													</Col>

													<Col
														lg={4}
														className="faq-battery-image"
													>
														<Image
															src="images/faq/right_earbud_in_case.svg"
															fluid
														/>
														<Col className="faq-battery-image-title">
															<small>Figure 2</small>
														</Col>
													</Col>
												</Row>
												<Row>
													<Col className="faq-battery-text">
														<br />
														<li>Close the lid of the Charging Case. </li>
														<small>
															<b>Optional:</b> Briefly press the button on the Charging Case (Figure 3) to view the current battery status of the Earbuds and the Charging Case. The lights will turn off after a few seconds tosave energy.
														</small>
													</Col>
													<Col
														lg={4}
														className="faq-battery-image"
													>
														<Image
															src="images/faq/pairing.svg"
															fluid
														/>
														<Col className="faq-battery-image-title">
															<small>Figure 3</small>
														</Col>
													</Col>
												</Row>
											</ol>
										</Col>

										<Row>
											<Col
												lg={4}
												className="faq-battery-image"
											>
												<Image
													src="images/faq/earbuds_in_case.svg"
													fluid
												/>
												<Col className="faq-battery-image-title">
													<small>Figure 4</small>
												</Col>
											</Col>
											<Col>
												<Table
													striped
													bordered
													size="sm"
												>
													<thead>
														<tr>
															<th>
																LED 1,2,3
																<p className="fw-normal">Figure 4</p>
															</th>
															<th className="">
																Description <br />
																<br />
															</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td>On </td>
															<td>Earbud/Charging Case is more than 25% charged</td>
														</tr>
														<tr>
															<td className="text-nowrap">On (Orange)</td>
															<td>Earbud/Charging Case is less than 25% charged</td>
														</tr>
														<tr>
															<td>On (Red)</td>
															<td>Earbud/Charging Case is less than 10% charged</td>
														</tr>
														<tr>
															<td>Off </td>
															<td>
																Charging Case battery is empty, or there is no connection between Earbud(s) and Charging Case charging contacts (lights turn off after a few seconds to save battery)
															</td>
														</tr>
														<tr>
															<td>Fade Animation</td>
															<td>Charging Case is charging (when the lid is closed, lights turn off after a few seconds)</td>
														</tr>
													</tbody>
												</Table>
												<small>Table 1: Battery level</small>
											</Col>
										</Row>
									</Row>
								</Tab.Pane>

								<Tab.Pane eventKey="cleaning-eop">
									<h2
										id="cleaning-eop"
										className="faq-menu-header"
									>
										How do I clean my EarsOnly Protect?
									</h2>
									<p>
										<i>
											<b> Warning:</b> Do not use any aggressive cleaning agents or solvents, like benzene, thinner, dishwashing liquid or alcohol as they may damage the surface. Contact the manufacturer for additional information.
										</i>
									</p>
									<Row
										xs={1}
										md={3}
									>
										<Col>
											<h5>Earbuds</h5>
											Wipe the outer surface of the Earbuds with a lightly dampened cloth. Ensure that the charging contacts are free from dirt.
											<Image
												src="images/faq/cleaning_earbuds.svg"
												fluid
											/>
										</Col>
										<Col>
											<h5>Charging Case</h5>
											Wipe the inside and outside of the Charging Case with a lightly dampened cloth. Ensure that the charging contacts are free from dirt.
											<Image
												src="images/faq/cleaning_case.svg"
												fluid
											/>
										</Col>
										<Col>
											<h5>Wax guards</h5>
											Periodic replacement of the wax guards is required to ensure correct functioning. Contact your supervisor or reseller when the wax guards are highly polluted or damaged.
											<Image
												src="images/faq/cleaning_filter.svg"
												fluid
											/>
										</Col>
									</Row>
									<Row>
										<p>
											<i>
												<b>Note:</b> Make sure that the Earbuds and Charging Case are fully dry before placing the Earbuds into the Charging Case
											</i>
										</p>
									</Row>
								</Tab.Pane>

								<Tab.Pane eventKey="app">
									<h2
										id="app"
										className="faq-menu-header"
									>
										MyEarsOnly app
									</h2>
									<Row>
										<Col id="explain">
											<Row
												className="pointer"
												id="row-geluidsinstellingen-a"
												onClick={() => {
													scrollToSVGandHighlight("geluidsinstellingen-a");
													highlightID("row-geluidsinstellingen-a");
												}}
											>
												<Col xs={1}>
													<Image src="images/icons/A.svg" />
												</Col>
												<Col xs={8}>
													<p>
														<b>Connection </b>
														Indicates if your Earbuds and
														Charging Case is connected to your device.
													</p>
												</Col>
											</Row>

											<Row
												className="pointer"
												id="row-geluidsinstellingen-b"
												onClick={() => {
													scrollToSVGandHighlight("geluidsinstellingen-b");
													highlightID("row-geluidsinstellingen-b");
												}}
											>
												<Col xs={1}>
													<Image src="images/icons/B.svg" />
												</Col>
												<Col xs={10}>
													<p>
														<b>Battery status </b>
														Provides real-time battery levels of your Earbuds and Charging Case.
													</p>
												</Col>
											</Row>

											<Row
												className="pointer"
												id="row-geluidsinstellingen-microphone"
												onClick={() => {
													scrollToSVGandHighlight("geluidsinstellingen-microphone");
													highlightID("row-geluidsinstellingen-microphone");
												}}
											>
												<Col xs={1}>
													<Image src="images/icons/Microphone.svg" />
												</Col>
												<Col xs={10}>
													<p>
														<b>Microphone </b>
														When in a call, the microphones of this side will be used
													</p>
												</Col>
											</Row>

											<Row
												className="pointer"
												id="row-geluidsinstellingen-charging"
												onClick={() => {
													scrollToSVGandHighlight("geluidsinstellingen-charging");
													highlightID("row-geluidsinstellingen-charging");
												}}
											>
												<Col xs={1}>
													<Image src="images/icons/Charging.svg" />
												</Col>
												<Col xs={10}>
													<p>
														<b>Charging </b>
														Indicates whether the Earbud or Charging Case is charging.
													</p>
												</Col>
											</Row>

											<Row
												className="pointer"
												id="row-geluidsinstellingen-c"
												onClick={() => {
													scrollToSVGandHighlight("geluidsinstellingen-c");
													highlightID("row-geluidsinstellingen-c");
												}}
											>
												<Col xs={1}>
													<Image src="images/icons/C.svg" />
												</Col>
												<Col xs={10}>
													<p>
														<b>Percentage </b>
														Battery percentage of Earbud or Charging Case.
													</p>
												</Col>
											</Row>

											<Row
												className="pointer"
												id="row-geluidsinstellingen-d"
												onClick={() => {
													scrollToSVGandHighlight("geluidsinstellingen-d");
													highlightID("row-geluidsinstellingen-d");
												}}
											>
												<Col xs={1}>
													<Image src="images/icons/D.svg" />
												</Col>
												<Col xs={10}>
													<p>
														<b>Sound/Settings </b>
														Switch between sound configurations and use Settings
													</p>
												</Col>
											</Row>

											<Row
												className="pointer"
												id="row-geluidsinstellingen-e"
												onClick={() => {
													scrollToSVGandHighlight("geluidsinstellingen-e");
													highlightID("row-geluidsinstellingen-e");
												}}
											>
												<Col xs={1}>
													<Image src="images/icons/E.svg" />
												</Col>
												<Col xs={10}>
													<p>
														<b>Hearing protection </b>
														Switch between the various hearing protection modes
													</p>
												</Col>
											</Row>

											<Row
												className="pointer"
												id="row-geluidsinstellingen-f"
												onClick={() => {
													scrollToSVGandHighlight("geluidsinstellingen-f");
													highlightID("row-geluidsinstellingen-f");
												}}
											>
												<Col xs={1}>
													<Image src="images/icons/F.svg" />
												</Col>
												<Col xs={10}>
													<p>
														<b>Audio balance </b>
														Adjust and fine-tune the audio balance in each ear.
													</p>
												</Col>
											</Row>

											<Row
												className="pointer"
												id="row-geluidsinstellingen-g"
												onClick={() => {
													scrollToSVGandHighlight("geluidsinstellingen-g");
													highlightID("row-geluidsinstellingen-g");
												}}
											>
												<Col xs={1}>
													<Image src="images/icons/G.svg" />
												</Col>
												<Col xs={10}>
													<p>
														<b>Music Equalizer  </b>
														Select an audio profile to match your preferred genre of music.
													</p>
												</Col>
											</Row>
										</Col>

										<Col className="app-image-instellingen">
											<Image
												src="images/icons/A.svg"
												onClick={() => {
													scrollToIDandHighlight("row-geluidsinstellingen-a");
													highlightSVG("geluidsinstellingen-a");
												}}
												id="geluidsinstellingen-a"
												className="pointer geluidsinstellingen-a"
											/>
											<Image
												src="images/icons/B.svg"
												onClick={() => {
													scrollToIDandHighlight("row-geluidsinstellingen-b");
													highlightSVG("geluidsinstellingen-b");
												}}
												id="geluidsinstellingen-b"
												className="pointer geluidsinstellingen-b"
											/>
											<Image
												src="images/icons/Microphone.svg"
												onClick={() => {
													scrollToIDandHighlight("row-geluidsinstellingen-microphone");
													highlightSVG("geluidsinstellingen-microphone");
												}}
												id="geluidsinstellingen-microphone"
												className="pointer geluidsinstellingen-microphone"
											/>
											<Image
												src="images/icons/Charging.svg"
												onClick={() => {
													scrollToIDandHighlight("row-geluidsinstellingen-charging");
													highlightSVG("geluidsinstellingen-charging");
												}}
												id="geluidsinstellingen-charging"
												className="pointer geluidsinstellingen-charging"
											/>

											<Image
												src="images/icons/C.svg"
												onClick={() => {
													scrollToIDandHighlight("row-geluidsinstellingen-c");
													highlightSVG("geluidsinstellingen-c");
												}}
												id="geluidsinstellingen-c"
												className="pointer geluidsinstellingen-c"
											/>
											<Image
												src="images/icons/D.svg"
												onClick={() => {
													scrollToIDandHighlight("row-geluidsinstellingen-d");
													highlightSVG("geluidsinstellingen-d");
												}}
												id="geluidsinstellingen-d"
												className="pointer geluidsinstellingen-d"
											/>
											<Image
												src="images/icons/E.svg"
												onClick={() => {
													scrollToIDandHighlight("row-geluidsinstellingen-e");
													highlightSVG("geluidsinstellingen-e");
												}}
												id="geluidsinstellingen-e"
												className="pointer geluidsinstellingen-e"
											/>
											<Image
												src="images/icons/F.svg"
												onClick={() => {
													scrollToIDandHighlight("row-geluidsinstellingen-f");
													highlightSVG("geluidsinstellingen-f");
												}}
												id="geluidsinstellingen-f"
												className="pointer geluidsinstellingen-f"
											/>
											<Image
												src="images/icons/G.svg"
												onClick={() => {
													scrollToIDandHighlight("row-geluidsinstellingen-g");
													highlightSVG("geluidsinstellingen-g");
												}}
												id="geluidsinstellingen-g"
												className="pointer geluidsinstellingen-g"
											/>

											<Image src={soundsettingsvg} />
										</Col>
									</Row>
								</Tab.Pane>
								<Tab.Pane eventKey="app2">
									<h2
										id="app2"
										className="faq-menu-header"
									>
										App settings
									</h2>
									<Row>
										<Col id="explain">
											<Row
												className="pointer"
												id="row-instellingen-a"
												onClick={() => {
													scrollToSVGandHighlight("instellingen-a");
													highlightID("row-instellingen-a");
												}}
											>
												<Col xs={1}>
													<Image src="images/icons/A.svg" />
												</Col>
												<Col xs={8}>
													<p>
														<b>Button configuration </b>
														Adjust the functions assigned to the tap and press buttons on each earbud.
													</p>
												</Col>
											</Row>

											<Row
												className="pointer"
												id="row-instellingen-b"
												onClick={() => {
													scrollToSVGandHighlight("instellingen-b");
													highlightID("row-instellingen-b");
												}}
											>
												<Col xs={1}>
													<Image src="images/icons/B.svg" />
												</Col>
												<Col xs={10}>
													<p>
														<b>Software update</b>
														Update your Earbuds and Charging Case.
													</p>
												</Col>
											</Row>

											<Row
												className="pointer"
												id="row-instellingen-c"
												onClick={() => {
													scrollToSVGandHighlight("instellingen-c");
													highlightID("row-instellingen-c");
												}}
											>
												<Col xs={1}>
													<Image src="images/icons/C.svg" />
												</Col>
												<Col xs={10}>
													<p>
														<b>Use instructions, FAQ and Troubleshooting</b>
													</p>
												</Col>
											</Row>
										</Col>

										<Col className="app-image-instellingen">
											<Image
												src="images/icons/A.svg"
												onClick={() => {
													scrollToIDandHighlight("row-instellingen-a");
													highlightSVG("instellingen-a");
												}}
												id="instellingen-a"
												className="pointer instellingen-a"
											/>
											<Image
												onClick={() => {
													scrollToIDandHighlight("row-instellingen-b");
													highlightSVG("instellingen-b");
												}}
												src="images/icons/B.svg"
												id="instellingen-b"
												className="pointer instellingen-b"
											/>
											<Image
												onClick={() => {
													scrollToIDandHighlight("row-instellingen-c");
													highlightSVG("instellingen-c--------------------------------------------------");
												}}
												src="images/icons/C.svg"
												id="instellingen-c"
												className="pointer instellingen-c"
											/>

											<Image src={settingsvg} />
										</Col>
									</Row>
								</Tab.Pane>

								<Tab.Pane eventKey="troubleshooting">
									<h2
										id="troubleshooting"
										className="faq-menu-header"
									>
										Troubleshooting
									</h2>
									<Accordion
										flush
										activeKey={accordionKey}
										onSelect={(key) => handleAccordionChange(key)}
										defaultActiveKey={"1"}
									>
										<Accordion.Item eventKey="1">
											<Accordion.Header>
												<b>Reset Earbuds & Reset Charging case</b>
											</Accordion.Header>
											<Accordion.Body>
												<b>Reset Earbuds</b>
												<ol>
													<li>Take the Earbuds out of the Charging case.</li>
													<li>Press and hold the Earbud buttons for 15 seconds.</li>
													<li>
														Place them back in the Charging case and wait 10 seconds.
														<br />
														<p>
															<i>
																<b>Note:</b> (preferred) settings will not be lost.
															</i>
														</p>
													</li>
												</ol>
												<b>Reset Charging case</b>
												<ol>
													<li>Press and hold the Charging case button for 15 seconds.</li>
												</ol>
											</Accordion.Body>
										</Accordion.Item>

										<Accordion.Item eventKey="2">
											<Accordion.Header>
												<b>After a long charge my Earbuds aren’t charged/fully charged</b>
											</Accordion.Header>
											<Accordion.Body>
												<ol>
													<li>Make sure the Earbuds are properly placed inside the Charging case.</li>
													<li>
														Make sure the Charging case still has charge (see:{" "}
														<a
															className="faq-link"
															href="#checking-battery"
															onClick={() => handleTabChange("checking-battery")}
														>
															“How do I check the battery levels and charge the batteries?”
														</a>
														)
													</li>
													<li>
														Clean both the charging contacts of the Earbud and the Charging case with a damp cloth. Place them back in the Charging case and check if the LEDs light up.
													</li>
													<li>
														If this doesn’t work perform a reset of the Earbuds and Charging case (see:{" "}
														<a
															href="#1"
															onClick={() => handleAccordionChange("1")}
															className="faq-link"
														>
															{" "}
															“Reset Earbuds & Reset Chargin case
														</a>
														) and try again.
													</li>
												</ol>
											</Accordion.Body>
										</Accordion.Item>

										<Accordion.Item eventKey="3">
											<Accordion.Header>
												<b>Earbud does not stream audio</b>
											</Accordion.Header>
											<Accordion.Body>
												<ol>
													<li>Make sure the Earbuds are connected to the audio source.</li>
													<li>Make sure the audio stream is playing.</li>
													<li>Place Earbud back in Charging case, wait 10 seconds and take them out again.</li>
													<li>If the audio stream stopped playing, start the audio stream again.</li>
													<li>
														Still no audio? Perform a reset of the Earbuds and try again (see:{" "}
														<a
															href="#1"
															onClick={() => handleAccordionChange("1")}
															className="faq-link"
														>
															{" "}
															“Reset Earbuds”
														</a>
														).
													</li>
												</ol>
											</Accordion.Body>
										</Accordion.Item>

										<Accordion.Item eventKey="4">
											<Accordion.Header>
												<b>The Earbuds won’t pair to my device</b>
											</Accordion.Header>
											<Accordion.Body>
												<ol>
													<li>Make sure the Charging case has been charged and is at least above 25%.</li>
													<li>Make sure the Earbuds are properly placed inside the Charging case.</li>
													<li>
														Check if both Earbuds are connected to the Charging case, press the Charging case button. Check if all LEDs light up.
													</li>
													<ol>
														<li>
															If all LEDs light up, follow the pairing instructions(see:{" "}
															<a
																onClick={() => handleTabChange("connect-bluetooth")}
																href="#connect-bluetooth"
																className="faq-link"
															>
																"How do I pair my EarsOnly Protect to a device?"
															</a>
															).
														</li>
														<li>
															If a LED does not light up, the corresponding Earbud is not connected to the Charging case. Pairing won’t work: Clean both the charging contacts of the Earbud and the Charging case with a damp cloth. Place the Earbud(s) back in the Charging case and check if the LEDs light up. If so, follow the pairing instructions (see: {" "}
															<a
																onClick={() => handleTabChange("connect-bluetooth")}
																href="#connect-bluetooth"
																className="faq-link"
															>
																"How do I pair my EarsOnly Protect to a device?"
															</a>
															)
														</li>
													</ol>
													<li>
														If this doesn’t work perform a reset of the Earbuds and Charging case and try again (see:{" "}
														<a
															href="#1"
															onClick={() => handleAccordionChange("1")}
															className="faq-link"
														>
															{" "}
															“Reset Earbuds & Reset Charging case
														</a>
														)
													</li>
												</ol>
											</Accordion.Body>
										</Accordion.Item>

										<Accordion.Item eventKey="5">
											<Accordion.Header>
												<b>The Earbuds won’t connect to my device</b>
											</Accordion.Header>
											<Accordion.Body>
												<ol>
													<li>Place the Earbuds back in the Charging case, wait 10 seconds and take them out again.</li>
													<li>
														Make sure the Earbuds are paired with your device, if this is not the case follow the pairing instructions  (see:{" "}
														<a
															onClick={() => handleTabChange("connect-bluetooth")}
															href="#connect-bluetooth"
															className="faq-link"
														>
															"How do I pair my EarsOnly Protect to a device?"
														</a>
														).
													</li>
													<li>
														If this doesn’t work, perform a reset of the Earbuds (see:{" "}
														<a
															href="#1"
															onClick={() => handleAccordionChange("1")}
															className="faq-link"
														>
															{" "}
															"Reset Earbuds”
														</a>
														) and try again.
													</li>
													<li>Reboot your device you are trying to connect to and try again.</li>
													<li>
														If this doesn’t work, remove the Earbuds from the Bluetooth pairing list on your device and re-pair the Earbuds to your device (see:{" "}
														<a
															onClick={() => handleTabChange("connect-bluetooth")}
															href="#connect-bluetooth"
															className="faq-link"
														>
															"How do I pair my EarsOnly Protect to a device?"
														</a>
														).
													</li>
												</ol>
											</Accordion.Body>
										</Accordion.Item>

										<Accordion.Item eventKey="6">
											<Accordion.Header>
												<b>Audio is out of sync</b>
											</Accordion.Header>
											<Accordion.Body>
												<ol>
													<li>Place the Earbuds in the Charging case, wait 10 seconds and take them out again.</li>
													<li>
														If this doesn’t work perform a reset of the Earbuds and try again (see:{" "}
														<a
															href="#1"
															onClick={() => handleAccordionChange("1")}
															className="faq-link"
														>
															{" "}
															“Reset Earbuds”
														</a>
														).
													</li>
												</ol>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="7">
											<Accordion.Header>
												<b>Factory reset</b>
											</Accordion.Header>
											<Accordion.Body>
												<p>
													<i>
														<b>Warning:</b> By returning to factory settings you will lose the (preferred) settings and the pairing information with your devices.
													</i>
												</p>
												<ol>
													<li>Make sure the Charging case has more than 25% charge.</li>
													<li>Make sure the Earbuds are properly placed inside the Charging case.</li>
													<li>Press and hold the button on the Charging Case for 3 seconds. Wait until all three lights blink; this may take up to 10 seconds.</li>
													<li>Quickly double press the Charging case button. The LEDs should now blink in a different colour.</li>
													<li> When the LEDs blink orange again the factory reset is successful. You can now pair your EarsOnly Protect to a device again. </li>
												</ol>
											</Accordion.Body>
										</Accordion.Item>
									</Accordion>
								</Tab.Pane>
								<Tab.Pane eventKey="downloads">
									<h2
										id="downloads"
										className="faq-menu-header"
									>
										Downloads
									</h2>
									<h3>Nederlands</h3>
									<hr />

									<ViewAndDownload
										title="Snel Start Gids"
										path="/documents/downloads/2024-03-04_SnelStartGids_007561-R1B.pdf"
									/>
									<ViewAndDownload
										title="Referentiegids"
										path="/documents/downloads/2024-06-07_ReferentieGids_NL_007562-R1C.pdf"
									/>
									<ViewAndDownload
										title="Veelgestelde vragen en Probleemoplossing"
										path="/documents/downloads/2024-06-27_EarsOnly_Protect-FAQ+Troubleshooting-NL.pdf"
									/>

									<br />
									<br />
									<br />
									<h3>English</h3>
									<hr />

									<ViewAndDownload
										title="Quick Start Guide"
										path="/documents/downloads/2024-02-19_QuickStart_007570_R1B.pdf"
									/>
									<ViewAndDownload
										title="Reference Guide"
										path="/documents/downloads/2024-06-07_ReferenceGuide_EN_007562-R1C.pdf"
									/>
									<ViewAndDownload
										title="Frequently asked questions and Troubleshooting"
										path="/documents/downloads/2024-06-10_EarsOnly_Protect-FAQ+Troubleshooting-EN.pdf"
									/>
								</Tab.Pane>
							</Tab.Content>
						</Col>
					</Row>
				</Tab.Container>
			</Container>
			<Footer />
		</>
	);
}
